/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Category_NeuroscienceInputs */

const en_why_listening_category_neuroscience = /** @type {(inputs: Why_Listening_Category_NeuroscienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuroscience`)
};

const es_why_listening_category_neuroscience = /** @type {(inputs: Why_Listening_Category_NeuroscienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neurociencia`)
};

/**
* | output |
* | --- |
* | "Neuroscience" |
*
* @param {Why_Listening_Category_NeuroscienceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_category_neuroscience = /** @type {((inputs?: Why_Listening_Category_NeuroscienceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Category_NeuroscienceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_category_neuroscience(inputs)
	return en_why_listening_category_neuroscience(inputs)
});